import AccountingInfoOption from './AccountingInfoOption';

export default class PaymentTerms extends AccountingInfoOption {
    public static entity = 'paymentTerms';
    public static apiType = 'payment-terms';
    public static storageKey = 'payment_terms_list';
}